import React, { useEffect, useState } from 'react';
import "./LatestNews.css";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import { Dialog } from '@material-ui/core';
import CloseIcon from "@material-ui/icons/Close";
import { db, storage } from "../firebase";
import firebase from "firebase";
import LatestNewsPost from './LatestNewsPost';

function LatestNews({ user }) {
    const [open, setOpen] = useState(false);
    const [scroll, setScroll] = React.useState("paper");
    const [caption, setCaption] = useState("");
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [latestNews, setLatestNews] = useState([]);

    const handleChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0])
        }
    }

    const handleOpenAddBox = (scrollType) => () =>  {
        setOpen(true);
        setScroll(scrollType);
    }

    const closeAddlatestNews = () => {
        setOpen(false)
        setCaption("");
        setImage(null);
    }

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open])

    const postNews = (e) => {
        if (220 - caption.length < 0) {
            alert("Your caption has crossed the world limit, so you can't post it.")
        } else {
            document.getElementsByClassName("progress")[0].style.display = "block";
            e.preventDefault();
            const uploadTask = storage.ref(`LN/${image.name}`).put(image);
            
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    // progress function...
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    setProgress(progress);
                },
                (error) => {
                    // Error function...
                    console.log(error);
                    alert(error.message);
                },
                () => {
                    // complete function...
                    storage
                    .ref("LN")
                    .child(image.name)
                    .getDownloadURL()
                    .then(url => {
                        // post image inside db
                        db.collection("latestNews").add({
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            caption: caption,
                            imageUrl: url,
                            username: user?.displayName,
                            photoURL: user?.photoURL,
                            likes: 0
                        });
    
                        setProgress(0);
                        setCaption("");
                        setImage(null);
                        closeAddlatestNews();
                       });
                }
            )
        }
    }

    useEffect(() => {
        db.collection("latestNews").orderBy("timestamp", "desc").onSnapshot((snapshot) => {
            setLatestNews(snapshot.docs.map(doc => ({
                id: doc.id,
                LN: doc.data()
            })))
        })
    }, [])


    return (
        <div className="latestNews">
            <Dialog open={open} scroll={scroll} onClose={closeAddlatestNews}>
                <div className="LatestNewsSender">
                    <div className="sender__haeder">
                    <h3>Share Latest News</h3>
                    <CloseIcon onClick={closeAddlatestNews} />
                    </div>
                    <div className="sender__input">
                        <textarea placeholder="Have a Latest or breaking news? If you want, you can share it with the world" value={caption} onChange={(e) => setCaption(e.target.value)}/>
                        <p>{220 - caption.length}</p>
                    </div>
                    <div className="warning">
                        <p>It is compulsory to post an image and a caption while you are sending a latest news.</p>
                    </div>
                    <div className="sender__footer">
                        <input type="file" onChange={handleChange} />
                        <button onClick={postNews} className="LNPB">POST</button>
                    </div>
                    <progress className="progress" value={progress} />
                </div>
            </Dialog>
            <div className="latestNews__header">
                <h2>Latest News</h2>
                <AddAlertIcon onClick={handleOpenAddBox("body")}  />
            </div>
            <div className="latestNews__body">
                {
                    latestNews.map(({id, LN}) => [
                        <LatestNewsPost key={id} LNId={id} user={user} username={LN.username} imageUrl={LN.imageUrl} photoURL={LN.photoURL} caption={LN.caption} likes={LN.likes} />
                    ])
                }
            </div>
        </div>
    )
}

export default LatestNews;